import { fromEnv } from "./fromEnv";

declare var newrelic: any;

const licenseKey = fromEnv("REACT_APP_NEWRELIC_LICENSE_KEY");

export class Logger {
  static initUser(userId: number) {
    newrelic?.setCustomAttribute("identifier", userId);
  }

  static info(...messages: any[]) {
    if (process.env.NODE_ENV === "development") {
      console.log("Logger.info", ...messages);
    }
  }

  static warn(content: any) {
    if (process.env.NODE_ENV === "development") {
      const stack = new Error().stack;
      console.warn("Logger.warn", { content, stack });
    }

    if (!!licenseKey) {
      newrelic?.noticeError(content, {
        tags: ["warning"],
      });
    }
  }

  static error(error: Error, tags: string[] = []) {
    if (process.env.NODE_ENV === "development") {
      console.error("Logger.error", error, tags);
    }

    if (!!licenseKey) {
      newrelic?.noticeError(error, {
        tags: ["error", ...tags],
      });
    }
  }
}
